import React from 'react';
import 'mfcl/variables.scss';
import { ProductPrice } from '@msdyn365-commerce/retail-proxy';
//** currently marking all as optional to excape errors */
import { ProductMattribute } from './product-mattribute';
import MsDyn365 from '@msdyn365-commerce/core';
import { SimpleProductAndAttributes } from '../mfrm-products-compare';
import { getAttributeArrayValueByNameUnbxd, getAttributeValueByNameUnbxd } from '../../../Utilities/getAttributeUtils';
import { IBooleanMattributesData } from '../mfrm-products-compare.props.autogenerated';
export interface IProductCompareCarouselItemProps {
    productUrl?: string | undefined,
    zipCode?: string | undefined,
    title: string | undefined,
    price: number | undefined,
    image: JSX.Element | null,
    basePrice: number,
    productBadge: JSX.Element | undefined,
    ratings: React.ReactNode | undefined,
    deliveryMessage?: React.ReactNode | undefined
    mattributeData?: any[],
    index: number,
    comfort?: string,
    mattressType?: string,
    heigth?: string,
    bestFor?: string,
    product?: SimpleProductAndAttributes,
    brandName?: string,
    context?: any,
    comfortIcon?: any,
    booleanMattributes?: IBooleanMattributesData[] | undefined;
}

export const ProductCompareCarouselItem: React.FC<IProductCompareCarouselItemProps> = (props) => {
    const { product, brandName, productUrl, price, image, title,
        basePrice, productBadge, ratings, deliveryMessage,
        mattributeData, index, comfort, mattressType, heigth, bestFor, comfortIcon, booleanMattributes } = props;
    function renderPrice(
        productPrice?: number,
        basePrice?: number
    ): JSX.Element | null {
        const price: ProductPrice = {
            BasePrice: basePrice,
            AdjustedPrice: basePrice,
            CustomerContextualPrice: productPrice
        };

        return basePrice ? (
            <div className="product-price">
                {price.AdjustedPrice && price.CustomerContextualPrice && price.CustomerContextualPrice < price.AdjustedPrice ? <>
                    <span className="product-dollars">${price.CustomerContextualPrice}</span>
                    <span className="product-original">
                        <span className="product-original-price">
                            <span className="product-dollars">${price.AdjustedPrice}</span>
                        </span>
                    </span>
                </> :
                    <span className="product-original price-text">
                        <span className="product-dollars">${price.BasePrice}</span>
                    </span>}
            </div>
        ) : null;
    }

    function renderMattributes(
        mattributeData: any,
        booleanMattributes?: IBooleanMattributesData[] | undefined
    ): JSX.Element | null {
        return mattributeData ? (
            <div className="product-mattributes">
                <h3 className="product-mattributes__heading">Mattributes</h3>
                {mattributeData?.sort((a: any, b: any) => a?.mattributeName > b?.mattributeName ? 1 : -1)?.sort((a: any, b: any) => {
                    if (booleanMattributes?.find(e => e?.mattributeName?.toUpperCase() === a?.mattributeName?.toUpperCase())) {
                        return 1;
                    } else if (booleanMattributes?.find(e => e?.mattributeName?.toUpperCase() === b?.mattributeName?.toUpperCase())) {
                        return -1;
                    } else {
                        return 0;
                    }
                }).map((mattribute: any, index: number) => {
                    return <ProductMattribute key={index} mattributeName={mattribute.mattributeName} mattributeValue={mattribute?.mattributeValue} mattributeScore={mattribute.score} booleanMattributes={booleanMattributes} />;
                })}
            </div>
        ) : null;
    }
    const callTealiumOnClick = async (): Promise<void> => {
        const productName = product?.Name;
        const variantID = getAttributeValueByNameUnbxd(product as any, 'v_VariantId');
        const productCategory = getAttributeArrayValueByNameUnbxd(product as any, 'categoryPathId2')?.at(-2)?.split('|')[1] ?? '';

        // @ts-ignore
        if ('utag' in window) {
            // @ts-ignore
            // tslint:disable-next-line: object-literal-key-quotes
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            utag.link({
                event: 'product-click',
                enhanced_action: 'product_click',
                event_category: 'ecommerce',
                event_action: 'product click',
                event_label: `${product?.ItemId}: ${productName}`,
                event_noninteraction: 'false',
                product_list_name: [`PDP Collection Compare`],
                product_position: [`${index}`],
                product_id: [`${product?.ItemId}`],
                product_name: [`${productName}`],
                product_category: [`${productCategory}`],
                product_brand: [`${brandName}`],
                product_variant: [`${variantID}`]
            });
        }
    };
   const  scrollToBuybox = () => {
    if(MsDyn365.isBrowser){
     const currentProduct= document.getElementById('mfrm-buybox');
     currentProduct?.scrollIntoView({
              behavior: 'smooth'
      });
      }
   };

   const renderCompareCard = () => {
       return (
           <>
               <div className='mfrm-product-badge'>
                   {productBadge}
               </div>
               <div className='product-compare-card__image' onClick={() => index !== 0 && callTealiumOnClick()}>
                   {image}
               </div>
               <div className='product-compare-card__details'>
                   <a href={productUrl} aria-label={title}>
                       <div className='product-compare-card__detail-title'>
                           <span className='product-compare-card__title' title={title}>
                               {title}
                           </span>
                       </div>
                       <div className='product-price-section'>
                           {renderPrice(
                               price, basePrice)
                           }
                       </div>
                       <div className='product-ratings'>
                           {ratings}
                       </div>
                       {deliveryMessage}
                   </a>
                   <div className='product-compare-card__specs'>
                       <div className='product-compare-card__specs-item'>
                           <span className='specs-lable'>Comfort</span>
                           <div className='comfort'>
                               <p className='specs'>{comfort ? comfort : '--'}</p>
                               <img src={comfortIcon} alt={`${comfort} icon`} className='comfort-icon' />
                           </div>
                       </div>
                       <div className='product-compare-card__specs-item'>
                           <span className='specs-lable'>Best For</span>
                           <p className='specs'>{bestFor ? bestFor : '--'}</p>
                       </div>
                       <div className='product-compare-card__specs-item'>
                           <span className='specs-lable'>Mattress Type</span>
                           <p className='specs'>{mattressType ? mattressType : '--'}</p>
                       </div>
                       <div className='product-compare-card__specs-item'>
                           <span className='specs-lable'>Height</span>
                           <p className='specs'>{heigth ? heigth : '--'}</p>
                       </div>
                   </div>
                   {renderMattributes(mattributeData, booleanMattributes)}
                   <div className='shop-ATC-buttons' onClick={() => index !== 0 && callTealiumOnClick()}>
                       {index === 0 ? <span className="shop-now-btn" onClick={() => scrollToBuybox()}>Shop Now</span>
                           : <a className="shop-now-btn" href={`${productUrl}`}>Shop Now</a>}
                   </div>
               </div>
           </>
    );
   };

    return (
        <div className={`product-compare-card ${index === 0 ? "current-product-border" : ''}`}>
            {index === 0 ?
                <div className='current-product' onClick={() => scrollToBuybox()}>
                    {renderCompareCard()}
                </div>
                :
                <a href={productUrl} aria-label={title} >
                    {renderCompareCard()}
                </a>
            }
        </div>
    );
};